import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, ICrudGetAllAction, getSortState, IPaginationBaseState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities, reset } from './asset-use.reducer';
import { IAssetUse } from 'app/shared/model/asset-use.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { getSession } from 'app/shared/reducers/authentication';

export interface IAssetUseProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const AssetUse = (props: IAssetUseProps) => {
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE), props.location.search)
  );
  const [sorting, setSorting] = useState(false);

  const getAllEntities = () => {
    props.getEntities(paginationState.activePage - 1, paginationState.itemsPerPage, `${paginationState.sort},${paginationState.order}`);
  };

  const resetAll = () => {
    props.reset();
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    props.getEntities();
  };

  useEffect(() => {
    resetAll();
    props.getSession();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      resetAll();
    }
  }, [props.updateSuccess]);

  useEffect(() => {
    getAllEntities();
  }, [paginationState.activePage]);

  const handleLoadMore = () => {
    if ((window as any).pageYOffset > 0) {
      setPaginationState({
        ...paginationState,
        activePage: paginationState.activePage + 1,
      });
    }
  };

  useEffect(() => {
    if (sorting) {
      getAllEntities();
      setSorting(false);
    }
  }, [sorting]);

  const sort = p => () => {
    props.reset();
    setPaginationState({
      ...paginationState,
      activePage: 1,
      order: paginationState.order === 'asc' ? 'desc' : 'asc',
      sort: p,
    });
    setSorting(true);
  };

  const { assetUseList, match, loading } = props;
  return (
    <div>
      <h2 id="asset-use-heading" className="card-heading">
        <Translate contentKey="assetApp.assetUse.home.title">Asset Uses</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
        </Link>
      </h2>
      <div className="table-responsive">
        <InfiniteScroll
          pageStart={paginationState.activePage}
          loadMore={handleLoadMore}
          hasMore={paginationState.activePage - 1 < props.links.next}
          loader={<div className="loader">Loading ...</div>}
          threshold={0}
          initialLoad={false}
        >
          {assetUseList && assetUseList.length > 0 ? (
            <Table responsive striped>
              <thead>
                <tr>
                  <th className="hand" onClick={sort('identifier')}>
                    <Translate contentKey="assetApp.assetUse.identifier">Identifier</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                  <th className="hand" onClick={sort('description')}>
                    <Translate contentKey="assetApp.assetUse.description">Description</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                  {props.authUser.root && <th className="hand" onClick={sort('providerId')}>
                    <Translate contentKey="assetApp.assetUse.provider">Provider</Translate> <FontAwesomeIcon icon="sort" />
                  </th>}
                </tr>
              </thead>
              <tbody>
                {assetUseList.map((assetUse, i) => (
                  <tr key={`entity-${i}`}>
                    <td>{assetUse.identifier}</td>
                    <td>{assetUse.description}</td>
                    {props.authUser.root &&
                      <td>{assetUse.providerId ? <Link className="btn-link" to={`provider/${assetUse.providerId}`}>{assetUse.providerIdentifier}</Link> : ''}</td>}
                    <td className="text-right">
                      <div className="btn-group flex-btn-group-container">
                        <Button tag={Link} to={`${match.url}/${assetUse.id}/edit`} color="primary" size="sm">
                          <FontAwesomeIcon icon="pencil-alt" />{' '}
                          <span className="d-none d-md-inline">
                            <Translate contentKey="entity.action.edit">Edit</Translate>
                          </span>
                        </Button>
                        <Button tag={Link} to={`${match.url}/${assetUse.id}/delete`} color="danger" size="sm">
                          <FontAwesomeIcon icon="trash" />{' '}
                          <span className="d-none d-md-inline">
                            <Translate contentKey="entity.action.delete">Delete</Translate>
                          </span>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            !loading && (
              <div className="alert alert-warning">
                <Translate contentKey="assetApp.assetUse.home.notFound">No Asset Uses found</Translate>
              </div>
            )
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

const mapStateToProps = ({ assetUse, authentication }: IRootState) => ({
  authUser: authentication.account,
  assetUseList: assetUse.entities,
  loading: assetUse.loading,
  totalItems: assetUse.totalItems,
  links: assetUse.links,
  entity: assetUse.entity,
  updateSuccess: assetUse.updateSuccess,
});

const mapDispatchToProps = {
  getEntities,
  getSession,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AssetUse);
